/* eslint-disable no-redeclare */
import {
  HealthcareSessionId,
  HealthcareUserId,
  NonEmptyText,
  Source,
  Url,
} from '@hc-frontend/core-types';
import { z } from 'zod';

/**
 * Parameters for refreshing the `landingUrl` (and `src` / `landingPage`) stored
 * on an existing prospect when a returning visitor re-enters on a new marketing
 * landing while keeping the same session (session operation `GET`).
 *
 * `src` is optional because a fresh landing may carry `utm_*`/`gclid` without a
 * `SRC`. `host` is optional for the same reason — it is only used to rebuild
 * `landingPage`, which is only sent when `src` is also known. See the adapter
 * for why the three fields move together.
 */
export const UpdateProspectLandingUrlParameters = z.object({
  sessionId: HealthcareSessionId,
  userId: HealthcareUserId,
  landingUrl: Url,
  src: Source.optional(),
  host: NonEmptyText.optional(),
});

export type UpdateProspectLandingUrlParameters = z.infer<
  typeof UpdateProspectLandingUrlParameters
>;
